'use strict';

angular.module('imagetrend.components')
    .directive('hlpFilter', [function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                //attributes
                filter: '=?'
            },
            require: '^hlpList',
            templateUrl: 'templates/list/filter/filter.html',
            link: function (scope, elem, attrs, ctrl) {
                if (!scope.filter) { scope.filter = {}; }
                if (!scope.filter.type) { scope.filter.type = 'select'; }
                if (!scope.filter.name) { scope.filter.name = scope.filter.type; }
                if (!scope.filter.options) { scope.filter.options = []; }
                if (scope.filter.showBlank == null) { scope.filter.showBlank = true; }
                if (scope.filter.type == 'userObj') {
                    scope.selectValue = 'user_id';
                } else {
                    scope.selectValue = 'id';
                }
                if (scope.filter.type == 'licenseLevel') {
                    scope.selectShow = 'combined_name';
                } else {
                    scope.selectShow = 'name';
                }

                scope.filterChanged = ctrl.filterChanged;
            }
        };
    }])
    ;